var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';
import { MarketingSettingsCacheKey } from '../config';
import queryFnFactory from './queryFnFactory';
export function useMarketingPreferencesQuery(_a) {
    var config = _a.config, keyProps = _a.keyProps, _b = _a.queryOptions, queryOptions = _b === void 0 ? {} : _b;
    return useQuery(__assign({ queryKey: MarketingSettingsCacheKey(keyProps), queryFn: queryFnFactory(config, keyProps) }, queryOptions));
}
